module.exports = __webpack_public_path__ + "img/relaxation.7875415e.png";